import { render, staticRenderFns } from "./paper-note-read-view.html?vue&type=template&id=5936da08&scoped=true&"
import script from "./paper-note-read-view.js?vue&type=script&lang=js&"
export * from "./paper-note-read-view.js?vue&type=script&lang=js&"
import style0 from "./paper-note-read-view.scss?vue&type=style&index=0&id=5936da08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5936da08",
  null
  
)

export default component.exports